import React from 'react';
import { VideoEmbedBlockStyles as S } from './VideoEmbedBlock.styles';
import { useInView } from '@hooks/useInView';
import { inViewMargin } from '@helpers/animate';
import ReactPlayer from 'react-player/lazy';
import { srcSet, imageUrl } from '@helpers/image';
import { from, Device } from '@helpers/media';
import SvgPlay from '@img/icons/cta-play.svg';
const VideoEmbedBlock = ({ data: { image, video, title, content }, }) => {
    const [refContainer, inView] = useInView({ rootMargin: inViewMargin });
    const [played, setPlayed] = React.useState(false);
    return (React.createElement(S.Container, { ref: refContainer, initial: "hidden", animate: inView ? 'visible' : 'hidden', variants: {
            hidden: {
                opacity: 0,
                y: 20,
            },
            visible: {
                opacity: 1,
                y: 0,
            },
        } },
        (title || content) && (React.createElement(S.TopContent, null,
            title && React.createElement(S.Title, null, title),
            content && React.createElement(S.Content, null, content))),
        played ? (React.createElement(S.VideoWrapper, null,
            React.createElement(ReactPlayer, { controls: true, playing: true, playsinline: true, url: video, height: "100%", width: "100%", style: {
                    position: 'absolute',
                } }))) : (React.createElement(S.ImageWrapper, { "aria-label": "Play Video", onClick: () => {
                setPlayed(true);
            } },
            React.createElement("picture", null,
                React.createElement("source", { media: from(Device.Desktop), srcSet: srcSet(image, { width: 1604, height: 904 }) }),
                React.createElement("source", { media: from(Device.DesktopSmall), srcSet: srcSet(image, { width: 1329, height: 749 }) }),
                React.createElement("source", { media: from(Device.TabletLarge), srcSet: srcSet(image, { width: 1243, height: 700 }) }),
                React.createElement("source", { media: from(Device.Tablet), srcSet: srcSet(image, { width: 987, height: 556 }) }),
                React.createElement("source", { media: from(Device.MobileLarge), srcSet: srcSet(image, { width: 731, height: 412 }) }),
                React.createElement(S.Image, { alt: image.altText, loading: "lazy", src: imageUrl(image, { width: 443, height: 250 }), srcSet: srcSet(image, { width: 443, height: 250 }) })),
            React.createElement(S.Button, null,
                React.createElement(SvgPlay, null))))));
};
export default VideoEmbedBlock;
